import { BaseItemModelService } from './base-item.model';
import { Injectable } from '@angular/core';
import { TemplateControlType } from './types/template-control-type';
import { isDefined } from '@fi-shared/utils/is-defined';
import { FiDocumentTemplateItemViewAdvancedTextComponent } from '../document-template/document-template-item-view/document-template-item-view-advanced-text.component';
import { FiDocumentTemplateItemOptionsAdvancedTextComponent } from '../document-template/document-template-item-options/document-template-item-options-advanced-text/document-template-item-options-advanced-text.component';
import { TemplatePlaceHolderControlModel } from '@fi-app/template/template-placeholder-control.model';

@Injectable()
export class AdvancedTextModelService {
    advancedTextItem: BaseItemModelService;
    model: TemplatePlaceHolderControlModel;
    //Settings: any;

    constructor(baseItemModel: BaseItemModelService) {
        this.advancedTextItem = Object.create(baseItemModel);
        this.advancedTextItem.init(
            'advancedText',
            TemplateControlType.HtmlText,
            FiDocumentTemplateItemViewAdvancedTextComponent,
            FiDocumentTemplateItemOptionsAdvancedTextComponent,
            'widget.default_advanced_text_name',
            'align-justifyCcmIcon',
            function (instance) {
                instance.model.Contents.forEach(function (content) {
                    content.Value.Text = '';
                    content.Value.AdditionalText = '';
                });
            },
        );

        Object.assign(this, this.advancedTextItem);
    }

    IsEmpty(contentLanguageId: number) {
        const content = this.model.Contents.find((c) => c.ContentLanguageId === contentLanguageId);
        if (!content) return true;

        if (isDefined(content.Value.Text) && content.Value.Text.length > 0) {
            return false;
        }

        if (
            this.model.Settings &&
            this.model.Settings.Columns == this.advancedTextItem.config.COLUMNS.TWO.id &&
            isDefined(content.Value.AdditionalText) &&
            content.Value.AdditionalText.length > 0
        ) {
            return false;
        }
        return true;
    }

    create() {
        return this.advancedTextItem.create.call(this.advancedTextItem);
    }
}
